import React from 'react';
import { DateField, NumberField, Show, TextField } from 'react-admin';
import { AmountField, LinkField } from '../../components/fields';
import { Grid, GridShowLayout } from '../../components/wrapper';
import PaymentShowActions from './PaymentShowActions';

const PaymentShow = props => (
	<Show {...props} actions={<PaymentShowActions />}>
		<GridShowLayout>
			<Grid container>
				<Grid item xs>
					<TextField source="id" />
					<DateField source="creationDateTime" showTime />
					<TextField source="paymentStatus" />
					<AmountField source="amount" />
					<LinkField source="paymentTransactionId" type={'Payment.PaymentResult'}/>
					<TextField source="paymentType" />
					<TextField source="customType" />
					<LinkField source="referencedPaymentId" type={'Payment'}/>
					<TextField source="paymentMethod" />
					<NumberField source="paymentCategoryCode" />
					<Grid container>
						<Grid item xs>
							<AmountField source="feeAmount" />
						</Grid>
						<Grid item xs>
							<AmountField source="feeAmountLC" label="resources.payments.label.feeAmountLC" />
						</Grid>
					</Grid>
					<TextField source="description" />
				</Grid>
				<Grid item xs>
					<LinkField source="walletId" type={'Wallet'} />
					<LinkField source="walletAccountId" type={'WalletAccount'} />
					<TextField source="walletAccountItemId" />
					<TextField source="walletAccountItemDisplayId" />
					<TextField source="paymentFlowType" />
					<LinkField source="paymentInstrumentId" type={'PaymentInstrument'} />
					<LinkField source="paymentOwner" />
					<TextField source="paymentSessionId" />
					<TextField source="paymentSettlementStatus" />
					<TextField source="manualSettlementComment" />
					<TextField source="paymentReversalTransactionId" />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default PaymentShow;
